import { FilterTypes } from '@shared/flight-itinerary/entities/filters';
import { isNullOrUndefined } from '@app/util/util';
import { AirFilterVm } from '@shared/magic-filter-bar/entities/filter-types';

const EXCLUDE_THESE_SELECTED_AIR_FILTERS = {
  [FilterTypes.Stops]: null,
  [FilterTypes.DepartureTimes]: null,
  [FilterTypes.SectorDurations]: null,
  [FilterTypes.PriceRange]: null,
  [FilterTypes.Airlines]: null,
};

export function getAirFiltersByBarWithCriteria(filters: AirFilterVm[]): AirFilterVm[] {
  const filteredByType = filters?.filter(filter =>
    filter.type === FilterTypes.Stops ||
    filter.type === FilterTypes.DepartureTimes ||
    filter.type === FilterTypes.SectorDurations ||
    filter.type === FilterTypes.PriceRange ||
    filter.type === FilterTypes.AirFilterTabs
  );
  const finalFilters = filteredByType?.filter(filter =>
    !Array.isArray(filter.value) || filter.value.length > 0
  ).map(filter => ({
    ...filter,
    order: getFilterBarOrder(filter.type)
  }));
  return finalFilters;
}

export function evalHasAirFilterByExcludeCollection(
  type: string,
  inFilterbar: boolean,
  defaultByInclude: boolean,
  include: boolean | null | undefined,
  criteria: string | null,
): boolean {
  if (!inFilterbar || !(type in EXCLUDE_THESE_SELECTED_AIR_FILTERS)) {
    return defaultByInclude ? !!include : !!criteria;
  } else {
    return !!include && !isNullOrUndefined(EXCLUDE_THESE_SELECTED_AIR_FILTERS[type]) && !!criteria &&
      EXCLUDE_THESE_SELECTED_AIR_FILTERS[type] !== criteria;
  }
}

function getFilterBarOrder(type: FilterTypes): number {
  switch (type) {
    case FilterTypes.Stops:
      return 1;
    case FilterTypes.DepartureTimes:
      return 2;
    case FilterTypes.SectorDurations:
      return 3;
    case FilterTypes.PriceRange:
      return 4;
    default:
      return 5;
  }
}
